import { HONOR_HALL_DEV_MOCK_PLAYER_NAMES } from './honorHallDevMockPlayerNames';

/** Dev-only (player1): shared mission depth so easy-count tiebreaker is visible. */
export const HONOR_HALL_EXPLORERS_DEV_MOCK_MISSION_DEPTH = 33;

const MOCK_FACTIONS = Object.freeze([
  'Exolot Dominion',
  'Asrah',
  'The Iron Alliance',
  'The Covenant',
  'Remnants of Humanity',
  'League of Shadows',
  "Ra's Children",
  'The Conspiracy',
  'The Divine Syndicate',
  'The Hollow',
]);

/**
 * Mock Honor Hall explorers rows — same depth, easy counts 0–19 (ascending rank tiebreaker).
 * @returns {Array<{
 *   rank: number,
 *   username: string,
 *   missions_completed: number,
 *   easy_missions_completed: number,
 *   run_strategy_name: string,
 *   faction_name: string,
 *   subscribe_strategy_id: null,
 *   is_owned: boolean,
 *   is_subscribed: boolean,
 * }>}
 */
export function buildHonorHallExplorersDevMockRows() {
  return HONOR_HALL_DEV_MOCK_PLAYER_NAMES.map((username, index) => {
    const easy = index;
    return {
      rank: index + 1,
      username,
      missions_completed: HONOR_HALL_EXPLORERS_DEV_MOCK_MISSION_DEPTH,
      easy_missions_completed: easy,
      run_strategy_name: easy === 0 ? 'Normal route' : `Alternative route (${easy} easy)`,
      faction_name: MOCK_FACTIONS[index % MOCK_FACTIONS.length],
      subscribe_strategy_id: null,
      is_owned: false,
      is_subscribed: false,
    };
  });
}
